/* eslint-disable no-dupe-keys */
export default {
  group: {
    name: '集团优惠',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '集团名称',
      serial_number: '集团码',
      logo: '集团LOGO',
      status: '状态',
      service_provider: '运营商',
      account_balance: '余额',
      payment_type: '支付类型',
      discount_type: '优惠类型',
      discount_stacking_type: '优惠叠加类型',
      users_count: '用户数',
      used_count: '优惠人次',
      created_at: '创建时间',
      updated_at: '更新时间',
      period_validity: '有效期',
      discount_info: '优惠信息',
      available_credit: '信用额度',
      account_balance_visible: '余额可视',
      charge_station: '充电站',
      audit_required: '审核机制',
      valid_time: '有效时间',
      qrcode: '申请二维码',
      remark: '备注',
      account_balance_visibles: '余额可视',
      available_amount: '可用金额',
      balance_not_enough: '余额不足',
      recurrence_rule_type: '重复周期',
      group_type: '集团类型',
      effective_days: '用户有效时长(天)',
      vin_verify: '是否验证VIN',
      settlement_type: '结算类型',
      station_scope: '电站范围'
    },
    titles: {
      base_info: '基本信息',
      using_limit: '使用限制',
      discount_info: '优惠定义',
      account_info: '账户信息',
      order_info: '运营统计',
      edit_discount: '设置优惠'
    },
    labels: {
      balance_not_enough_count: '余额不足数',
      total_group_account_balance_count: '共享资金池数',
      total_audit_not_required_count: '免审核数',
      total_in_progress_count: '生效中',
      stations: '充电站',
      group_discount: '优惠折扣'
    },

    // Enum的属性
    statuses: {
      disabled: '暂停',
      expired: '过期',
      in_progress: '生效中',
      pending: '未生效'
    },
    payment_types: {
      group_account_balance: '共享资金池',
      user_account_balance: '用户余额'
    },
    station_scope: {
      all_stations: '全部电站',
      specified_stations: '指定电站'
    },
    settlement_types: {
      no_settlement: '不结算',
      normal_settlement: '正常结算'
    },
    group_types: {
      enterprise_group: '普通集团',
      family_group: '家庭集团',
      community_group: '社群集团'
    },
    discount_types: {
      service_fee_discount: '服务费折扣',
      discount: '总价折扣',
      billing_rule: '费率'
    },
    filter_recurrence_rule_type: {
      daily: '每天',
      weekly: '每周'
    },
    recurrence_rule_type: {
      daily: '每天',
      weekday: '工作日',
      weekly: '每周'
    },
    discount_stacking_types: {
      exclusive: '优惠互斥',
      unrestricted: '优惠叠加'
    },
    list_tabs: {
      all: '全部',
      enterprise_group: '普通集团',
      family_group: '家庭集团',
      community_group: '社群集团'
    },
    // Boolean的属性
    account_balance_visibles: {
      true: '用户可见',
      false: '对用户隐藏'
    },
    balance_not_enoughs: {
      true: '不足',
      false: '充足'
    },
    // 需要审核
    audit_requireds: {
      true: '人工审核',
      false: '免审核'
    },
    // 是否验证VIN
    vin_verifys: {
      true: '验证',
      false: '不验证'
    },
    placeholder: {
      input_name: '某某集团/家庭/社群',
      search_keyword: '查询集团名称',
      search_station: '优惠的电站',
      serial_number: '集团码用于申请加入时使用，如：L00001',
      description: '输入备注内容，该内容App可见 （200字以内）'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      group_applications: '集团用户',
      orders: '订单',
      transaction_records: '账单流水'
    },
    remainingTime: '剩余：{0} 天 {1} 小时 {2} 分钟',
    pendingTime: '距离生效：{0} 天 {1} 小时 {2} 分钟',
    expired: '已过期',
    btn: {
      application: '用户申请',
      transaction: '充值/提现'
    },
    tips: {
      qrcode_scan: '微信扫码加入集团',
      enterprise_group: '普通集团的优惠不对非集团成员展示，适用一般内部优惠',
      family_group: '家庭集团适用于私人充电站，成员一般是免充值、免费在自己的桩上充电',
      community_group: '社群集团类似会员优惠，可在充电站上展示社群价格，引导用户加群享优惠',
      settlement_type: '当平台代收资金池款项，可以设置为正常结算。'
    },
    group_titles: {
      base: '基础信息',
      discount_type: '优惠类型',
      condition: '适用范围'
    }
  }
}
